import { render, staticRenderFns } from "./giftModal.vue?vue&type=template&id=e93a2532&scoped=true"
import script from "./giftModal.vue?vue&type=script&lang=ts"
export * from "./giftModal.vue?vue&type=script&lang=ts"
import style0 from "./giftModal.vue?vue&type=style&index=0&id=e93a2532&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93a2532",
  null
  
)

export default component.exports